import React from 'react';
import './UserFooter.css';


const UserFooter = () => {
  return (
    <footer className="user-footer">
      
    </footer>
  );
};

export default UserFooter;
